import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService, UserRole } from '@nebalkon-workspace/auth';

export interface RoleGuardConfig {
  allowedRoles?: UserRole[];
  excludedRoles?: UserRole[];
}

export const roleGuard = (config: RoleGuardConfig): CanMatchFn => () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return router.createUrlTree(['/auth']);
  }

  const userRoles = authService.roles();

  // Whitelist: разрешить только указанные роли
  if (config.allowedRoles) {
    if (userRoles.some((role) => config.allowedRoles!.includes(role))) {
      return true;
    }
    return router.createUrlTree(['/client']);
  }

  // Blacklist: разрешить всё, кроме указанных ролей
  if (config.excludedRoles) {
    if (userRoles.some((role) => config.excludedRoles!.includes(role))) {
      return router.createUrlTree(['/client']);
    }
    return true;
  }

  return true;
};
